import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ConfigurationService } from '@draeger-academy/common/lib/services/configuration/configuration.service';
import { Course } from 'models/course';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'da-tab-section',
    templateUrl: './tab-section.component.html',
    styleUrls: ['./tab-section.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabSectionComponent implements OnInit {
    @Input() data;
    @Input() site;
    public course: Course = null;

    private _$isString: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public description: any;
    public url: string;
    public showEventTab: boolean;
    public get isString$(): Observable<boolean> {
        return this._$isString.asObservable();
    }

    private _$showDownload: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showDownload$(): Observable<boolean> {
        return this._$showDownload.asObservable();
    }

    constructor(protected changeDetectorRef: ChangeDetectorRef, private _configurationService: ConfigurationService) {}

    ngOnInit(): void {
        if (this.data) {
            this.course = new Course(this.data);
            if (this.course && this.course.events && this.course.events.length > 0) {
                this.showEventTab = true;
            } else {
                this.showEventTab = false;
            }
        }
        const site = this._configurationService.getSiteFromUrl();
        if (site) {
            this.site = site.site;
        }

        if (this.course && this.course.training && this.course.training.description) {
            try {
                const desc = JSON.parse(this.course.training.description);
                this._$isString.next(false);
                this.description = desc;
            } catch {
                if (
                    this.course &&
                    this.course.training &&
                    this.course.training.description &&
                    typeof this.course.training.description === 'string'
                ) {
                    this._$isString.next(true);
                    this.description = this.course.training.description;
                }
            }
        }

        this._$showDownload.next(this._configurationService.hasFeature('DownloadCourseDescription'));

        if (this.course && this.course.id) {
            this.url = `${environment.APIEndpoint}api/v1/course/getcoursedescription/${this.course.id}`;
        }
    }

    public isString(value) {
        const desc = JSON.parse(value);
        this.description = desc;
        return typeof this.description === 'string' || this.description instanceof String;
    }
}
